var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_196_1876",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_196_1876",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEK0lEQVR4nO2dz4tcRRDHOxJF/IGK4FlIDpqDl8Wp2jUw11zEix71H1DQmyfZq2g2KIiwvio3LmhAiDlIDgb0ouBFQTQ3FfGgQYzZ17URIbq21BjBkN2dnfdmprp76gMFO7PTb977frur3ut9/TYEx3Ecx3Ecx3Ecx3EyJ62GW2KDj0eGz4Txi8j4TFodHrber+r5lVbujgTPC+EPwphuCH2P4MX2zeP3We9ndWxtwIOR8WVhuHKT8DcFiBC+rm2s97t42gaWhHEzMvw5XvgbIzLuCMGHwnDc+jhKzu9pSuF1old+5ymF14m++R2nFF4neuV3mVIsXJ2YUX5PXidyyO/sdSKT/I5eJ3LI77JodSLz/J6qvZ4oKr9zRdcTZed3LPd6oqb8LiXWCeuDlczDDWA3wLwXio8AeyHEU5C9GGIQXgPYDTDvheIjwF4I8RRkL4YYhNcArtyAcfTdQSm8vTnWAogbULaA4iMA3YA+WPdA8RFQtoDiKQjdgD5Y90DxEVC2gOIpCN2APlj3QPERULaA4ikIMzYAfgy5Y90DZcrtI+O1yPhWpJXllMKhkDu5CSg92keCD9rTK0dCSeQkoHRsHwn+0PtdQ4nkIKD0aU94VRiHoVTMBeSe7Rt8LJSMuYDcr33xWAsobkDdBrQNHhXGNV0tM1obQXg1Ml4UglPCg2PBmloNSKvDw8LwymgtwB7bjgR/6YKNtL50a7CiRgPSSHy8MG7b/4sLZibUaID8m3LShPFasKA2A9oGj+6XdvZMR7qEq4GHw7ypzQAZFdeJe/9/sRbmTXUGsJ7tdDMgMnwT5k19BkCPZbggYd5YCyh5GbAd5o21gJJVCsKLYd5UZwDhye4jwOBUtDYD2tMrR7qdhuKObCw/NOn3ObsgjK9O3PsJTu22LacDOq0ghOcPLj6eT+8fu63Ldzn7zQcRntQ/0u+ddkYPMFkznYyrnVano7UwE3wpjL8LwVYk/Gp0xew533Ecx5klPa4Ks4pI+Lc+em17c/mBUBJ1iA9ftw0OQokULz7j2Z/Wl+4IpVK2+HAuq4eudsFaROkc8K0+ZHaSY43vPHq/vD14QhheioxnIuGnQvDd9fuB4vURtaOvI+PPQvi9fiYSkD7YVdtubQzvdQMY0zYtP3UQIa6sL92zzYNnhfHzLrOgu6S8a5HwY93mVFKffU/GyYPw8rj5mdGzrxlfEIbfZrUfkfCSGtFroYe5mNypF36y3zH98sbwLmH8aI77c/bS5iN3djahJlIKh7Q4z79TwLkiljzNmkiDp+1G5+DJsOhEPbPJNDUuBKJz+mYjwOC2ldyQcSIRXhaGd9sGn2sbPKH3e+r8kf7zBj1z0tCf9T39nX5GPysE7x3kjCosOjJGoLQxvL3rtrWtGzCGWQvkBozBDTDGDTDGDTDGDQiLbcA/vrR2Q5fxaocAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccount);
export default __webpack_public_path__ + "static/media/Bank Account.f68c4eb9aa5e7edbd05d1fc634220348.svg";
export { ForwardRef as ReactComponent };